<template>
  <main>
    <Header></Header>
    <main class="cateraway-contanier">
      <!-- banner -->
      <section class="banner-box" v-if="windowWidth <= 480">
        <el-image style="width: 100%; height: 250px" :src="require('../../assets/images/pc_banner.png')" fit="cover" lazy></el-image>
        <div class="banner-content">
          <h1 class="content-h2-title"> {{ $t("message.menuh1") }} </h1>
          <p class="content-h3-title"> {{ $t("message.menuh2") }} </p>
          <section style="display:flex;justify-content:center;">
            <div class="buttons" @click="openLink(webUrl)">
              <img style="width:25px;height:25px" src="../../assets/images/el-icon-my-shopping.png" alt="">
              <p>{{ $t("message.buttons.linkButton") }}</p>
            </div>
            <div class="buttons" style="background:#2DA739;border-color:#2DA739" @click="openLink(whatsappUrl)">
              <img style="width:25px;height:25px" src="../../assets/images/el-icon-my-whatsapp.png" alt="">
              <p>{{ $t("message.buttons.whatsApp") }}</p>
            </div>
          </section>
        </div>
      </section>
      <!-- services -->
      <div class="services" v-if="windowWidth <= 480">
        <div class="services-content">
          <el-row :gutter="20">
            <el-col :span="12" style="margin-bottom:20px">
              <el-row :gutter="10" type="flex" align="middle">
                <el-col :span="6">
                  <el-image style="width: 100%; height: 100%" :src="require('../../assets/images/pc_icon1_icon.png')"
                            fit="cover" lazy></el-image>
                </el-col>
                <el-col :span="18">
                  <div>
                    <p class="service-title">{{ $t("message.menu.span.title1") }}</p>
                    <p class="service-sub-title">{{ $t("message.menu.span.content1") }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" style="margin-bottom:20px">
              <el-row :gutter="10" type="flex" align="middle">
                <el-col :span="6">
                  <el-image style="width: 100%; height: 100%" :src="require('../../assets/images/pc_icon2_icon.png')"
                            fit="cover" lazy></el-image>
                </el-col>
                <el-col :span="18">
                  <div>
                    <p class="service-title">{{ $t("message.menu.span.title2") }}</p>
                    <p class="service-sub-title">{{ $t("message.menu.span.content2") }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" style="margin-bottom:20px">
              <el-row :gutter="10" type="flex" align="middle">
                <el-col :span="6">
                  <el-image style="width: 100%; height: 100%" :src="require('../../assets/images/pc_icon3_icon.png')"
                            fit="cover" lazy></el-image>
                </el-col>
                <el-col :span="18">
                  <div>
                    <p class="service-title">{{ $t("message.menu.span.title3") }}</p>
                    <p class="service-sub-title">{{ $t("message.menu.span.content3") }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" style="margin-bottom:20px">
              <el-row :gutter="10" type="flex" align="middle">
                <el-col :span="6">
                  <el-image style="width: 100%; height: 100%" :src="require('../../assets/images/pc_icon4_icon.png')"
                            fit="cover" lazy></el-image>
                </el-col>
                <el-col :span="18">
                  <div>
                    <p class="service-title">{{ $t("message.menu.span.title4") }}</p>
                    <p class="service-sub-title">{{ $t("message.menu.span.content4") }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <header class="cateraway-discount-title" v-if="windowWidth > 480">
        <section class="title-first">
          <p>{{ $t("message.caterwayReserve.marqueeTitle.zero") }}</p>
        </section>
        <section class="title-second">
          <ul :class="{marquee_top:animate}" style="height:28px;">
            <li v-for="(item, index) in msg" :key="index">
              <p v-if="$i18n.locale === 'zh'">{{ item.titleZh }}</p>
              <p v-else>{{ item.titleEn }}</p>
            </li>
          </ul>
        </section>
      </header>
      <section class="banner-box" v-if="windowWidth > 480">
        <el-image style="width: 100%; height: 300px" :src="url" fit="cover" :lazy="true"></el-image>
        <div class="banner-content">
          <h1 class="content-h2-title"> {{ $t("message.caterwayReserve.banner.title") }} </h1>
          <p class="content-h3-title"> {{ $t("message.caterwayReserve.banner.subTitle") }} </p>
          <section style="display:flex">
            <div class="buttons" @click="openLink(webUrl)">
              <img style="width:25x;height:25px" src="../../assets/images/el-icon-my-shopping.png" alt="">
              <p>{{ $t("message.buttons.linkButton") }}</p>
            </div>
            <div class="buttons" style="background:#2DA739;border-color:#2DA739" @click="openLink(whatsappUrl)">
              <img style="width:25x;height:25px" src="../../assets/images/el-icon-my-whatsapp.png" alt="">
              <p>{{ $t("message.buttons.whatsApp") }}</p>
            </div>
          </section>
        </div>
      </section>
      <ProductMenus></ProductMenus>
      <!-- <MenusList :tags="tagCategory" :products="products" :title="title" v-if="products.length > 0 && windowWidth > 480"/>
      <MobileMenusList :tags="tagCategory" :products="products" v-if="products.length > 0 && windowWidth <= 480"/> -->
      <div class="activity-contanier">
        <div class="activity-main">
          <Title :title="$t('message.caterwayReserve.context.h2TitleOne')"></Title>
          <Content :content="$t('message.caterwayReserve.context.pContentOne')"></Content>
        </div>
      </div>
      <div class="activity-contanier">
        <div class="activity-main">
          <Title :title="$t('message.caterwayReserve.context.h2TitleSecond')"></Title>
          <Content :content="$t('message.caterwayReserve.context.pContentSecond')"></Content>
          <Content :content="$t('message.caterwayReserve.context.pContentSecondTwo')"></Content>
        </div>
      </div>
      <div class="activity-contanier">
        <div class="activity-main">
          <Title :title="$t('message.caterwayReserve.context.h2TitleThird')"></Title>
          <Content :content="$t('message.caterwayReserve.context.pContentThird')"></Content>
        </div>
      </div>
      <div class="faq-contanier">
        <div class="faq-main">
          <Title :title="$t('message.caterwayReserve.aboutMenuTitle')"></Title>
          <div class="feq-content">
            <div class="about-food-main">
              <div v-for="item in 4" :key="item" style="margin-left:10px">
                <h3 style="color: #000">{{ $t(`message.caterwayReserve.aboutMenu.faq${item}`) }}</h3>
                <div style="margin-left:10px" class="feq-content-text">
                  {{ $t(`message.caterwayReserve.aboutMenu.content${item}`) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- 彈窗廣告 -->
    <section>
      <div ref="catebday" class="catebday">
        <span @click="close">×</span>
        <a href="https://order.cateraway.com/">
          <img class="imgBox" src="../../assets/images/menu_dialog.png" alt="" />
        </a>
      </div>
      <div class="curtain" ref="curtain" @click="close"></div>
    </section>
  </main>
</template>

<script>
import Header from "../../components/header";
import Title from '../../components/common/title.vue'
import Content from '../../components/common/content.vue'
import ProductMenus from './components/ProductMenus.vue';
import websiteApi from "../../../api/website";

export default {
  data() {
    return {
      url: require('../../assets/images/pc_banner.png'),
      windowWidth: document.documentElement.clientWidth,
      whatsappUrl: "https://api.whatsapp.com/send?phone=85264586539&text=hello%20%E5%88%B0%E6%9C%83%E5%AE%B6,%E6%88%91%E6%83%B3%E8%A8%82%E5%88%B0%E6%9C%83%EF%BC%81%F0%9F%98%8B%F0%9F%98%8B",
      webUrl: "https://order.cateraway.com/",
      animate: false,
      setInTime: '', // 定时器
      time:null,
      msg: [],
      title: "尋找適合您的到會",
    }
  },
  components: {
    ProductMenus,
    Header,
    Title,
    Content
  },
  mounted() {
    this.getMsg()
    // this.initCountdown()
    this.$nextTick(() => {
      this.windowWidth = document.documentElement.clientWidth;
    })
    window.addEventListener("resize", () => {
      this.windowWidth = document.documentElement.clientWidth;
    });
    this.setInTime = setInterval(this.showMarquee, 3000)
  },
  methods: {
    getMsg(){
      websiteApi.getWebsiteSwiperTitle('0da8d60a138edba7918a6517ccd49c9c').then(result => {
        const { data } = result
        this.msg = data
      })
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    initCountdown(){ 
      this.time = setTimeout(() => {
        var curtain = this.$refs.curtain;
        curtain.style.display = "block";
        const catebday = this.$refs.catebday
        catebday.style.display = "block";
        this.time = null
      }, 2000);
    },
    close() {
      const catebday = this.$refs.catebday;
      var curtain = this.$refs.curtain;
      catebday.style.display = "none";
      curtain.style.display = "none";
      this.time = null
    },
    // 滚动栏滚动
    showMarquee() {
      this.animate = true
      setTimeout(() => {
        this.msg.push(this.msg[0])
        this.msg.shift()
        this.animate = false
      }, 500)
    }
  },
  destroyed() {
    clearInterval(this.setInTime) // 页面销毁时清除定时器
  },
  unmounted() {
    window.removeEventListener("resize")
  },
}
</script>

<style lang="less" scoped>
.catebday {
  width: 30%;
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 2s; /* don't forget to set a duration! */
  --animate-delay: 2s;
  // display: none;
  position: fixed;
  z-index: 999;
  left: 50%;
  display: none;
  transform: translateX(-50%);
  top: 5%;
  @media (max-width: 1200px) {
    width: 50%;
    top: 5%;
  }
  @media (max-width: 840px) {
      top: 10%;
      width: 70%;
  }
  @media (max-width: 567px) {
    top: 20%;
    width: 90%;
  }
  .imgBox{
    width: 100%;
  }
}
.curtain {
  width: 100%;
  height: 100%;
  z-index: 900;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(20, 20, 21, 0.5);
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 2s; /* don't forget to set a duration! */
  --animate-delay: 2s;
  display: none;
}
.cateraway-contanier {
  box-sizing: border-box;
  width: 70%;
  margin: 150px auto 30px;
  @media all and (max-width: 1660px) {
    width: 80%;
  }
  @media all and (max-width: 1440px) {
    width: 85%;
  }
  @media all and (max-width: 1200px) {
    width: 90%;
  }
  @media all and (max-width: 768px) {
    width: 95%;
  }
  @media all and (max-width: 480px) {
    margin: 140px auto 30px;
    width: 100%;
  }

  .banner-box {
    margin: 30px 0;
    position: relative;
    width: 100%;

    .banner-content {
      position: absolute;
      top: 50%;
      left: 0;
      color: #fff;
      margin-left: 50px;
      transform: translateY(-50%);
      @media all and (max-width: 480px) {
        left: 50%;
        margin-left: 0px;
        transform: translate(-50%, -50%);
      }

      .content-h2-title {
        font-weight: 500;
        font-size: 32px;
        margin: 10px 0;
      }

      .content-h3-title {
        font-weight: lighter;
        margin: 10px 0;
        font-size: 20px;
      }

      .buttons {
        cursor: pointer;
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #EB6100;
        border: 1px solid #EB6100;
        color: #fff;
        font-size: 18px;
        padding: 5px;
        border-radius: 8px;
        margin-right: 20px;
        @media all and (max-width: 700px) {
          width: 150px;
          font-size: 14px;
        }
      }
    }
  }

  .services {
    margin: 30px 0;

    .services-content {
      padding: 0px 10px;
      text-align: center;
      border-bottom: 1px solid #dbdbdb;

      .service-title {
        color: #000;
        margin-bottom: 10px;
      }

      .service-sub-title {
        color: #919599;
        font-size: 13px;
      }
    }
  }

  .cateraway-discount-title {
    width: 90%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    margin: 30px auto;
    font-size: 700;
    border: 5px solid #EB6100;
    font-size: 20px;
    @media all and (max-width: 850px) {
      width: 100%;
      font-size: 18px;
    }
    @media all and (max-width: 555px) {
      font-size: 18px;
    }

    .title-first {
      background: #EB6100;
      color: #fff;
      height: 28px;
      padding: 0 20px;
    }

    .title-second {
      color: #EB6100;
      text-align: center;
      flex: 1;
      overflow: hidden;
    }

    .marquee_top {
      transition: all 0.5s;
      margin-top: -28px; /* 容器高度 */
    }
  }

  .select-title {
    text-align: center;
    color: #EB6100;
    font-size: 32px;
    font-weight: 500;
    @media all and (max-width: 1200px) {
      font-size: 28px;
    }
    @media all and (max-width: 555px) {
      font-size: 28px;
    }
    @media all and (max-width: 478px) {
      font-size: 24px;
    }
  }

  .activity-contanier {
    background-image: url("../../assets/images/bodybg.jpg");
    background-size: 100% 100%;

    .activity-main {
      width: 70%;
      padding: 3% 2%;
      margin: 0 auto;
      @media (max-width: 1255px) {
        width: 90%;
      }

      .activity-content-main {
        display: flex;
        justify-content: space-around;
        @media (max-width: 768px) {
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .activity-item ~ .activity-item {
          margin-left: 30px;
          @media (max-width: 768px) {
            margin-left: 0px;
          }
        }

        .activity-item {
          text-align: center;
          flex: 0 0 30%;
          @media (max-width: 768px) {
            flex: 0 0 48%;
          }
          @media (max-width: 480px) {
            flex: 0 0 100%;
            display: flex;
            margin-bottom: 3%;
            text-align: left;
          }

          .activity-item-img {
            .item-img {
              width: 100%;
              height: 100%;
            }

            @media (max-width: 480px) {
              flex: 0 0 48%;
            }
          }

          .activity-item-content, .activity-item-span {
            margin: 20px;
          }

          .activity-item-content {
            font-size: 1.2vw;
            font-weight: 550;
          }

          .activity-item-span {
            font-size: 13px;
            color: #919599;
            font-weight: 350;
          }

          .item-button {
            @media (max-width: 480px) {
              margin: 0 20px;
            }
          }
        }
      }
    }
  }

  .faq-contanier {
    .faq-main {
      width: 70%;
      margin: 0 auto;
      @media (max-width: 1255px) {
        width: 90%;
      }

      .feq-content {
        margin: 0 0 3%;
        font-size: .825rem;
        color: #919599;

        .feq-content-text {
          margin-bottom: 3%;
        }
      }

    }
  }
}
</style>
